import React from "react";
import "./comparisonSalientFeatures.css";
import iconSave from "assets/comparison/optimized_cost1.png";
import iconFreeSupport from "assets/comparison/optimized_cost2.png";
import iconUnderstand from "assets/comparison/optimized_cost3.png";
import iconSalesTeam from "assets/comparison/optimized_cost4.png";
import iconGoLive from "assets/comparison/optimized_cost5.png";

const ComparisonSalientFeatures = ({ title }) => {

    return (<div className="salient-features-section--outer" id="comparison-salient-features">
        <h4>{title}</h4>
        <div className="salient-features">
            <div className="salient-single-feature">
                <div className="salient-single-feature--img">
                    <img alt="Save 85% on your CRM" src={iconSave} />
                </div>
                <div className="salient-single-feature--content">
                    <h5>Save 85% on your CRM</h5>
                    <p>Zero Customization Cost Save up to 4 Lakhs approx</p>
                </div>
            </div>
            <div className="salient-single-feature">
                <div className="salient-single-feature--img">
                    <img alt="Avail Free Product Support" src={iconFreeSupport} />
                </div>
                <div className="salient-single-feature--content">
                    <h5>Avail Free Product Support</h5>
                    <p>Get Dedicated Consultants Save More than 1 Lakh approx</p>
                </div>
            </div>
            <div className="salient-single-feature">
                <div className="salient-single-feature--img">
                    <img alt="Get a CRM that Understands Real Estate" src={iconUnderstand} />
                </div>
                <div className="salient-single-feature--content">
                    <h5>Get a CRM that Understands Real Estate</h5>
                    <p>Exclusively Designed for Real Estate by the Real Estate Experts</p>
                </div>
            </div>
            <div className="salient-single-feature">
                <div className="salient-single-feature--img">
                    <img alt="Give your Sales Team an Easy to Use CRM" src={iconSalesTeam} />
                </div>
                <div className="salient-single-feature--content">
                    <h5>Give your Sales Team an Easy to Use CRM</h5>
                    <p>Only 3 hrs of Specialized Training Required</p>
                </div>
            </div>
            <div className="salient-single-feature">
                <div className="salient-single-feature--img">
                    <img alt="Go Live in Just 3 Days" src={iconGoLive} />
                </div>
                <div className="salient-single-feature--content">
                    <h5>Go Live in Just 3 Days</h5>
                    <p>Plug-n-Sell Real Estate CRM Save 3 Months of Setup Time</p>
                </div>
            </div>
        </div>
    </div>);
};

export default ComparisonSalientFeatures;
